<template name="categoryList">
	<div class="category_main">
		<div style="border-right: 1px solid #EEEEEE;min-width: 200px;max-width:200px;overflow: auto;">
		<div class="custom-tree-container">
		  <div class="block">
			  <el-tree
				node-key="id"
				:data="category" 
				@node-click="handleNodeClick" 
				:highlight-current="true"
				default-expand-all
				:default-expanded-keys="defaultShowKey"
				ref="treeSelect"
				:check-on-click-node="true">
				<span class="custom-tree-node" slot-scope="{ node, data }">
				  <span v-if="data.type == 'normal'">{{ node.label }}</span>
				  <el-input :id="'inputName'+data.id" class="add_input" v-model="inputName" type="text" v-else placeholder="输入分组名称" maxlength="10" @blur="blurInput(node,data)" @change="changeInput(node,data)"></el-input>
				  <span>
					<el-button :id="'addbtn'+data.id" v-if="data.type == 'normal'" type="text" size="mini" class="app_btn" @click.stop="append(data,node)">
					  <i class="el-icon-plus"></i>
					</el-button>
				  </span>
				</span>
			  </el-tree>
			</div>
		</div>
		</div>
	</div>
</template>

<script>
	import {
		getCategoryList,
		saveCategory
	} from '@/api/depot_category';
	var is_execute = true;
	export default {
	    data() {
			return {
				defaultShowKey: [0],
				category: [],
				inputName:'',
				category_id:0,
				is_add_input:true,
				is_focus:true
			}
	    },
		watch:{
			is_search: function(newVal, oldVal){
				if(newVal){
					var that = this;
					that.category_id = 0;
					setTimeout(function(){
						that.$refs['treeSelect'].setCurrentKey(0)
					},100)
				}
			}
		},
		props: {
			category_type: {
				type: Number,
				default: 1
			},
			is_search:{
				type: Boolean,
				default: false
			}
			
		},
		created(){
			this.getCategory();
		},
	    methods: {
			// 获取节点数据
			getCategory() {
				var that = this;
				getCategoryList({
					type: that.category_type
				}).then(res => {
					if (res.code == 0) {
						that.category = res.data;
						const _e = {id:res.data[0].id};
						that.handleNodeClick(_e);
						
						setTimeout(function(){
							that.$refs['treeSelect'].setCurrentKey(0);
							document.getElementById('addbtn0').setAttribute('style', 'color: #1989FA !important;background-color: #F2F6FC !important');
						},100)
					} else {
						that.$message.error(res.message);
					}
				})
			},
			// 点击节点
			handleNodeClick(e){
				if(this.category_id == e.id){
					return;
				}
				
				var allobj = document.getElementsByClassName('app_btn');
				allobj.forEach(function(o){
					o.setAttribute('style', 'color: #999999 !important;background-color: none !important');
				})
				
				
				this.category_id = e.id;
				var obj = document.getElementById('addbtn'+e.id);
				obj.setAttribute('style', 'color: #1989FA !important;background-color: #F2F6FC !important');
				this.$emit('chooseCategory',this.category_id);
			},
			// 追加节点
			append(data,node) {
				var that = this;
				// console.log(node);
				if(!that.is_add_input){
					return;
				}
				that.is_add_input = false;
				const newChild = { pid:data.id ,id: -1, label: '', children: [],type:'input' };
				if (!node.data.children) {
				  that.$set(node.data, 'children', []);
				}
				node.data.children.push(newChild);
				that.defaultShowKey.push(Number(node.data.id));
				that.$nextTick(() => {
					setTimeout(function(){
						console.log(document.querySelector(`#inputName-1`));
						document.querySelector(`#inputName-1`).focus();
						document.querySelector(`#inputName-1`).select();
					},100)
				})
			},
			// 文本框失去焦点
			blurInput(node,data) {
				var that = this;
				that.is_add_input = true;
				
				if(that.inputName.trim() == '' && is_execute == true){
					that.inputName = '';
					that.remove(node,data);
				}else{
				}
			},
			// 文本框内容改变
			changeInput(node,data){
				var that = this;
				that.is_add_input = true;
				if(that.inputName.trim() == ''){
					that.inputName = '';
					that.remove(node,data);
					is_execute = true;
				}else{
					is_execute = false;
					// 接口保存
					saveCategory({
						pid:data.pid,
						type:that.category_type,
						name:that.inputName
					}).then(res=>{
						if(res.code == 0){
							node.data.id = res.data;
							node.data.type = 'normal';
							// node.data.btn_show = false;
							node.data.label = that.inputName;
							that.inputName = '';
							// var elem = document.getElementById("inputName");
							// console.log(elem)
							// elem.remove("inputName");
						}
					})
				}
			},
			// 展示添加节点按钮
			// showBtn(node){
			// 	node.data.btn_show = true;
			// },
			// 隐藏添加节点按钮
			// hideBtn(node){
			// 	node.data.btn_show = false;
			// },
			// 移除节点
			remove(node, data) {
				const parent = node.parent;
				const children = parent.data.children || parent.data;
				const index = children.findIndex(d => d.id === data.id);
				children.splice(index, 1);
			}
	    }
	};
</script>

<style scoped>
	.category_main{
		width: 100%;
		min-height: 800px;
		max-height: 800px;
		background-color: #ffffff;
		display: flex;
	}
	.category_main >>> .el-tree-node__content{
		height: 30px;
		margin-top: 17px;
		padding-right: 20px;
	}
	.category_main .custom-tree-container{
		width: fit-content;
		min-width: 200px;
		padding-top: 13px;
	}
	.custom-tree-container .custom-tree-node {
	    align-items: center;
	    justify-content: space-between;
	    font-size: 12px;
	    padding-right: 8px;
		color: #666666;
	}
	.custom-tree-container .app_btn{
		color: #999999;
		width: 20px;
		height: 20px;
		padding: 0;
		font-size: 13px;
		margin-left: 4px;
	}
	.custom-tree-container .app_btn i{
		font-weight: bold;
	}
	.custom-tree-container >>> .add_input input{
		min-width: 106px;
		background: #F5F5F5;
		border: none;
		height: 30px;
		font-size: 12px;
	}
	.custom-tree-container >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content{
		background-color: #ffffff;
	}
	.custom-tree-container >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content > .custom-tree-node {
	    color: #1989FA !important;
	}
</style>